import { createReducer } from '../../utils';
import types from './types';

// TODO For sure it is a not a proper way to handle caching, double check it next time
export let cache = {};

export const initialState = {
    tabs: [],
    open: {
        campaigns: null,
        grid: null
    },
    upcoming: {
        campaigns: null,
        grid: null
    },
    recommendation: [],
    selectedFilter: 'all',
    categorySlideIndex: 0,
    isWelcomeBoxOpen: false,
    isLoading: false,
    errors: [],
    getImagesLoaded: false,
};

const ASYNC_ACTION_HANDLERS = {
    [types.UPDATE_MYLOUNGE.REQUEST]: state => ({
        ...state,
        isLoading: true
    }),

    [types.UPDATE_MYLOUNGE.SUCCESS]: (state, action) => ({
        ...state,
        ...action.payload,
        isLoading: false,
        errors: []
    }),

    [types.UPDATE_MYLOUNGE.ERROR]: (state, action) => ({
        ...state,
        isLoading: false,
        errors: [action.payload]
    }),

    [types.UPDATE_OPEN_CAMPAIGNS.REQUEST]: (state, action) => ({
        ...state,
        isLoading: true,
        selectedFilter: action.payload
    }),

    [types.UPDATE_OPEN_CAMPAIGNS.SUCCESS]: (state, action) => ({
        ...state,
        open: action.payload,
        isLoading: false,
        errors: []
    }),

    [types.UPDATE_OPEN_CAMPAIGNS.ERROR]: (state, action) => ({
        ...state,
        open: {},
        errors: [action.payload]
        // TODO set isLoading flag to false
    }),

    [types.FETCH_MY_RECO.SUCCESS]: (state, action) => ({
        ...state,
        recommendation: action.payload,
    }),
};

const SYNC_ACTION_HANDLERS = {
    [types.FILTER_CHANGED]: (state, action) => ({
        ...state,
        isWelcomeBoxOpen: false,
        selectedFilter: action.payload
    }),

    [types.UPDATE_SLIDE_INDEX]: (state, action) => {
        if (action.payload >= 0 && action.payload < state.tabs.length) {
            return ({
                ...state,
                categorySlideIndex: action.payload
            });
        }

        return state;
    },

    [types.TOGGLE_WELCOME_BOX]: state => ({
        ...state,
        isWelcomeBoxOpen: !state.isWelcomeBoxOpen
    }),

    [types.CLOSE_WELCOME_BOX]: state => ({
        ...state,
        isWelcomeBoxOpen: false
    }),

    [types.UPDATE_IMAGES_LOADED]: (state, action) => ({
        ...state,
        imagesLoaded: action.payload
    }),

    // TODO OMG what is this
    [types.RESET_CACHE]: state => {
        cache = {};

        // do not modify state, just reset cache
        return state;
    }
};

const ACTION_HANDLERS = {
    ...SYNC_ACTION_HANDLERS,
    ...ASYNC_ACTION_HANDLERS
};

export default createReducer(ACTION_HANDLERS, initialState);
